module.exports = __webpack_public_path__ + "img/compleja.8610ca24.png";